import { TRAINEE_TYPE } from "../TrainingManagement/CONSTANTS";

export const initialForm = {
  staffType: "",
  searchTxt: "",
};

export const STAFF_TYPE_OPTION = Object.keys(TRAINEE_TYPE).map((key) => ({
  name: TRAINEE_TYPE[key],
  id: key,
}));

export const STAFF_TYPE_KEY = {
  employee: "employee",
  contractorPerson: "contractorPerson",
};
